import WatermarkerCanvasEditor from "./WatermarkerCanvasEditor";

export default WatermarkerCanvasEditor;
